const mutations = {
    setBlogPosts(state, posts) {
        state.posts = posts
    },
    setBlogPost(state, currentPost) {
        state.currentPost = currentPost
    },
    setUserPosts(state, userPosts) {
        state.userPosts = userPosts
    },
    setDraftPosts(state, drafts) {
        state.drafts = drafts
    },
    addDraftPosts(state, drafts) {
        state.drafts.push(...drafts)
    },
    addBlogPosts(state, posts) {
        state.posts.push(...posts)
    },
    reachedBottom(state, value) {
        state.reachedBottom = value
    },
    draftsReachedBottom(state, value) {
        state.draftsReachedBottom = value
    },
    addUserPosts(state, userPosts) {
        state.userPosts.push(...userPosts)
    }
}

export default mutations